import { mapGetters } from 'vuex';

import {
  getLanguageSlug,
  i18n,
} from '@/i18n';

export default {
  computed: {
    ...mapGetters([
      'getSiteLocaleBase',
      'isGlobalUser',
    ]),
    guidedSearchUrl() {
      return this.localizeGlobalUrl('gs');
    },
    supportUrl() {
      return this.localizeGlobalUrl('support');
    },
  },

  methods: {
    getFrenchPath(englishPath) {
      switch (englishPath) {
        case 'legal/privacy':
          // PHP route('legal.privacy.index')
          return 'legal/confidentialite';
        case 'legal/terms':
          // PHP route('legal.terms.index')
          return 'legal/termes';
        default:
          return englishPath;
      }
    },
    legalUrl(englishPath) {
      const path = i18n.locale === 'fr-CA'
        ? this.getFrenchPath(englishPath)
        : englishPath;

      return this.localizeUrl(path);
    },
    localizeGlobalUrl(path) {
      return this.localizeUrl(path, this.isGlobalUser ? 'en' : null);
    },
    localizeLanguageUrl(path) {
      return this.localizeUrl(path, getLanguageSlug());
    },
    localizeUrl(path, localeBase = null) {
      return `${window.location.origin}/${localeBase ?? this.getSiteLocaleBase}/${path.replace(/^\//, '')}`;
    },
  },
};
